import React from "react";
import "./PageContainer.css";

export interface PageContainerProps {
  children: React.ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "full";
  padding?: "none" | "sm" | "md" | "lg";
  className?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  maxWidth = "xl",
  padding = "md",
  className = "",
}) => {
  return (
    <div
      className={`page-container max-${maxWidth} padding-${padding} ${className}`}
      data-testid="page-container"
    >
      {children}
    </div>
  );
};

export default PageContainer;
